import { ErrorTagUtil } from '@onshape/www-inertia';
import TrackingUtil from '../../../../../util/TrackingUtil';
import ErrorUtil from '../../../../../util/ErrorUtil';
import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import AbstractSignupScreen from './AbstractSignupScreen';

export default class ErrorOutSignupScreen extends AbstractSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-error-out';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public getProgress(): number {
    return 0;
  }

  public predicate(): boolean {
    const { isErroredOut } = this.sessionInfo.value;
    return isErroredOut;
  }

  public toNextScreen(): Promise<boolean> {
    throw new Error('Method not implemented.');
  }

  public override trackEvent(screenName?: UnifiedSignupScreenName): void {
    super.trackEvent(screenName);
    TrackingUtil.mouseFlowPush(['tag', 'uss-error-out']);
    ErrorUtil.safePostMessageToSentry({
      tag: ErrorTagUtil.hekateUnifiedSignup,
      msg: 'User reached error out screen in unified signup',
    });
  }
}
